// The current address with some query parameters changed (an empty value removes one). Built from the address bar itself, not from the
// render's copy: two quick changes (a filter, then typing in the search box) must both survive.
export function patchedSearch(patch, search = typeof window === "undefined" ? "" : window.location.search) {
  const next = new URLSearchParams(search);
  for (const [key, value] of Object.entries(patch)) {
    if (value) next.set(key, value);
    else next.delete(key);
  }
  return next;
}
